import { PageWrapper } from "../login/login.styles";
import LoginPane from "../login-pane/login-pane.component";
import LoginCanvas from "../login-canvas/login-canvas.component";
import React from "react";
import { LoginViewProps } from "./login-view.props";

export const LoginView = (props: LoginViewProps) => (
  <PageWrapper>
    <LoginPane
      userData={props.userDataValues}
      errors={props.errors}
      loading={props.loading}
      rememberMe={props.rememberMe}
      handleChange={props.onChange}
      handleRemeberMe={props.onRememberMe}
      handleSubmit={props.onSubmit}
      handleForgotPassword={props.onForgotPassword}
    />
    <LoginCanvas />
  </PageWrapper>
);
